import { CURRENT_CLIENT } from '@/constants/index'

export type SocialProviderConfig = {
  id: string
  label: string
  enabled?: boolean
}

export type SocialAuthConfig = {
  enabled?: boolean
  signupEnabled?: boolean
  providers?: SocialProviderConfig[]
}

export function getSocialAuthConfig(): SocialAuthConfig {
  const auth = (CURRENT_CLIENT as { auth?: { social?: SocialAuthConfig } }).auth
  return (auth?.social ?? {}) as SocialAuthConfig
}

export function socialAuthEnabled(): boolean {
  return Boolean(getSocialAuthConfig().enabled)
}

export function getEnabledSocialProviders(): SocialProviderConfig[] {
  const config = getSocialAuthConfig()
  if (!config.enabled) return []
  return (config.providers ?? []).filter((provider) => provider.enabled !== false)
}

/** Browser callback URL after OAuth (same origin as Labs). */
export function getSocialProviderCallbackUrl(): string {
  if (typeof window === 'undefined') {
    return '/auth/provider/callback'
  }
  return `${window.location.origin}/auth/provider/callback`
}
